export {default as StatusBadge} from './status-badge-view';
